export const PolicyDocumentTypes = {
    SIGNED: "signed",
    UNSIGNED: "unsigned",
};